<template>
  <div class="admin-only-page">
    <!-- Page Header -->
    <div class="page-header mb-6">
      <div class="d-flex align-center mb-2">
        <v-icon size="large" color="red-darken-3" class="me-3">mdi-shield-account</v-icon>
        <span class="text-h4 font-weight-bold">Admin Only</span>
      </div>
      <p class="text-body-1 text-grey-darken-1">
        Administrative tools and configurations for 2026. Access restricted to authorized administrators only.
      </p>
    </div>

    <!-- Admin Tools -->
    <v-row no-gutters>
      <v-col cols="12" sm="6" md="4" lg="4" class="pa-0">
        <!-- Partner Switcher Card -->
        <partner-switcher @partner-changed="handlePartnerChange" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import PartnerSwitcher from '../components/PartnerSwitcher.vue';
import Card from '../components/ui/Card.vue';

export default defineComponent({
  name: 'AdminOnly2026',
  components: {
    PartnerSwitcher,
    Card
  },
  computed: {
    currentEnvironment() {
      return import.meta.env.VITE_ENV_HOOK || 'Unknown';
    }
  },
  methods: {
    handlePartnerChange(partner) {
      console.log('Partner changed in admin page:', partner);
      // Additional admin-specific handling if needed
    }
  }
});
</script>

<style scoped>
.admin-only-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.page-header {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 16px;
}

@media (max-width: 960px) {
  .admin-only-page {
    padding: 16px;
  }
}
</style>
